import type { SearchResults } from '@ghostscreen/contracts';
import { contentAssetPath } from '../../pages/content/contentRoutes';
import { displayManagePath } from '../../pages/displays/manage/displayManageRoutes';
import { playlistPath } from '../../pages/playlists/playlistRoutes';

export type SearchResultKind = 'screen' | 'playlist' | 'image' | 'video';

export type SearchResultGroup = 'screens' | 'playlists' | 'content';

export type SearchResultItem = {
  key: string;
  group: SearchResultGroup;
  kind: SearchResultKind;
  label: string;
  to: string;
};

/** Flat, keyboard-navigable list in display order: screens, playlists, content. */
export function buildSearchResultItems(results: SearchResults): SearchResultItem[] {
  return [
    ...results.screens.map((hit) => ({
      key: `screen-${hit.id}`,
      group: 'screens' as const,
      kind: 'screen' as const,
      label: hit.name,
      to: displayManagePath(hit.id),
    })),
    ...results.playlists.map((hit) => ({
      key: `playlist-${hit.id}`,
      group: 'playlists' as const,
      kind: 'playlist' as const,
      label: hit.name,
      to: playlistPath(hit.id),
    })),
    ...results.media.map((hit) => ({
      key: `media-${hit.id}`,
      group: 'content' as const,
      kind: hit.kind,
      label: hit.name,
      to: contentAssetPath(hit.id),
    })),
  ];
}
